import { EchallengeImages } from "./enums";

export const CHALLENGE_IMAGE_PREFIX = "/assets/images/challenge-placeholders/";
export const IMAGE_CONFIG = {
  emotional_investing: EchallengeImages.screenCapture,
  importance_diversification: EchallengeImages.importance_diversification,
  unpredictable_markets: EchallengeImages.screenCapture,
  breaking_even: EchallengeImages.screenCapture,
  sequence_risk: EchallengeImages.sequence_risk,
  safe_investments: EchallengeImages.safe_investments,
  investment_risk: EchallengeImages.investment_risk,
  behind_numbers: EchallengeImages.behind_numbers,
  test_your_confidence: EchallengeImages.screenCapture,
  longevity: EchallengeImages.screenCapture,
  safe_withdrawal: EchallengeImages.safe_withdrawal,
  interest: EchallengeImages.screenCapture,
  inflation: EchallengeImages.screenCapture,
  income_gap: EchallengeImages.income_gap,
  tax_triangle: EchallengeImages.tax_triangle,
  tax_ratio: EchallengeImages.tax_ratio,
  taxes_time: EchallengeImages.screenCapture,
  market_expectations: EchallengeImages.screenCapture,
};
export const TITLE_CONFIG = {
  emotional_investing: "Emotional Investing",
  importance_diversification: "Importance of Diversification",
  unpredictable_markets: "Unpredictable Markets",
  breaking_even: "Breaking even",
  sequence_risk: "Sequence of returns risk",
  safe_investments: `"Safe" investments and real returns`,
  investment_risk: "Investment risk",
  behind_numbers: "Behind the numbers",
  test_your_confidence: "Test your confidence",
  longevity: "Longevity - planning for a longer retirement",
  safe_withdrawal: "Running out of money",
  interest: "Living off your interest?",
  inflation: "Inflation can erode your purchasing power",
  income_gap: "Income gap",
  tax_triangle: "Understanding tax strategies",
  tax_ratio: "Reducing tax drag on your returns",
  taxes_time: "Comparing taxable and tax-deferred accumulation",
  market_expectations: "Market Expectations",
  rates: "Rates",
};
export const INDEX_CONFIG = {
  "sp_500": "S&P 500",
  sp_500_russell_2000: "S&P 500/Russell 2000 (Lesser of)",
  "russell_2000": "Russell 2000",
  nasdaq: "Nasdaq 100",
  msci_eafe: "MSCI EAFE",
  msci_emerging_markets: "MSCI Emerging Markets",
  ishares: "iShares U.S. Real Estate ETF",
};
export const SEGMENT_CONFIG = {
  1: "1-Year",
  2: "2-Year",
  3: "3-Year",
  6: "6-Year",
};
export const BUFFER_CONFIG = {
  buffer_10: "-10% Buffer",
  buffer_15: "-15% Buffer",
  buffer_20: "-20% Buffer",
  buffer_25: "-25% Buffer",
  buffer_100: "-100% Buffer",
  trigger_30: "30% Trigger",
};
export const CATEGORY_CONFIG = {
  standard: "Standard",
  dual: "Dual Directional",
  annual_lock: "Annual Lock",
  contingent_return: "Contingent Return",
  income_choice: "Income Choice",
  annual_fee: "Standard with Annual Fee",
  dual_directional_w_annual_fee: "Dual Directional with Annual Fee",
};
export const ECART_DEFAULT_USER_INFO = {
  clientName: "",
  advisorName: "",
  advisorPhone: "",
  advisorDesignations: [],
  advisorCustomDesignation: "",
  includeHistoricalPerformanceData: false,
  includeCurrentRatesData: false,
  ratesArrangedBy: "category",
  ratesIndexes: "individual",
};
